module.exports = __webpack_public_path__ + "static/media/cask-end-overlay.ac993b47.png";